export const verifyToken=(token)=> {
    try {
      const [header, payload, signature] = token.split('.');
  
      // Decode the payload without verifying the signature
      const decodedPayload = JSON.parse(atob(payload));
  console.log(decodedPayload)
      // Check expiration time
      if (decodedPayload.exp * 1000 < Date.now()) {
        return false; // Token has expired
      }
  
      // Other checks if needed...
  
      return true; // Token is valid based on the checks performed
    } catch (error) {
      return false; // Token decoding or other checks failed
    }
  }